<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mdueio/images/GreatHusbandHu-cover.jpg?1733085690286" alt="This image is the cover for the book Great Husband Hunt"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Great Husband Hunt
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of <i>The Future Homemakers of America</i> comes the hilarious and moving story of one unstoppable woman's unforgettable ride through an ever-changing century..</b><br/><br/>What hope is there for Poppy Minkel? She has kinky hair, big ears, skin that's too sallow, and an appetite for fun. Poppy's mother, Dora, despairs of ever finding her a husband, despite the lure of the family fortune offered by Minkel's Mighty Fine Mustard.<br/><br/>Correctness, duty, and Dora Minkel Ear Correcting Bandages are the weapons in this husband hunt-and they serve as torture to a girl who has her own hazy ideas about beauty, love, and marriage. After the sudden death of her father, Poppy's rebelliousness bursts into full bloom. From one World War to the next, from New York to Paris, she'll invent her own extraordinary life with never a moment of self-doubt...as acclaimed author Laurie Graham treats us to a rollicking, exhilarating celebration of passion over prudence.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laurie Graham
      </h2>
      
      <p class="authorDescription body article">Laurie Graham is a journalist, scriptwriter and novelist. She lives in County Dublin, Ireland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Warner Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0965c579